module.exports = __webpack_public_path__ + "static/media/so-stock--chicken3.df1caf86.jpg";